import { render, staticRenderFns } from "./verificationNew.vue?vue&type=template&id=3cb789d8&scoped=true&"
import script from "./verificationNew.vue?vue&type=script&lang=js&"
export * from "./verificationNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb789d8",
  null
  
)

export default component.exports